<template>
  <div>
    <h3 class="mb-4 sidebar-header secondary--text">Let's get started</h3>
    <p>
      <strong>Hello, {{ fullName }}</strong
      >!<br />
      Welcome to the {{ $orgWarehouseName }} scheduling system
    </p>
    <p class="mt-6">Don't forget to check the warehouse information before proceeding.</p>

    <book-appointment-link
      :label="`${
        novaCore.isRequested($appointmentCreationStatus) ? 'Request' : 'Book'
      } Appointment`"
      icon="mdi-arrow-right"
      class="mt-4 primary-button"
      :to="{ path: `/warehouse/${$warehouseId}/schedule` }"
      large></book-appointment-link>

    <div v-if="$warehouseAmenities?.length > 0">
      <h4 class="mb-5 mt-8">Amenities available:</h4>
      <div v-for="amenity in $warehouseAmenities" :key="amenity">
        <v-chip dense color="blue lighten-4" class="mb-3">
          <div class="mr-2">
            <img height="12" width="12" :src="`/images/warehouse/${getAmenityIcon(amenity)}.png`" />
          </div>
          <small>
            {{ amenity.toUpperCase() }}
          </small>
        </v-chip>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    getAmenityIcon(amenity) {
      const index = Object.values(this.novaCore.AmenitiesEnum).indexOf(amenity);
      return Object.keys(this.novaCore.AmenitiesEnum)[index];
    }
  },
  computed: {
    fullName() {
      return `${this.$me?.firstName} ${this.$me?.lastName}`;
    }
  }
};
</script>
